require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-sponsors-mozel-sanders-foundation-scholarships-2022.json") })
        }
      }, "path---articles-financial-center-sponsors-mozel-sanders-foundation-scholarships-2022");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-sponsors-mozel-sanders-foundation-scholarships-2022!./.cache/json/articles-financial-center-sponsors-mozel-sanders-foundation-scholarships-2022.json
// module id = 1677
// module chunks = 231608221292675